import React from "react";
import { ExerciseForHourlySchedule } from "../../../models/ExerciseForHourlySchedule";
import { useMediaQuery } from "@mui/material";
import "../style.scss";
import HourlyScheduleDesktopTable from "./HourlyScheduleDesktopTable";
import HourlyScheduleMobileTable from "./HourlyScheduleMobileTable";
import BuyTicketsButton from "./BuyTicketsButton";

interface IProps {
  data: { [name: string]: ExerciseForHourlySchedule[] } | undefined;
  selectedDate: Date;
}

const HourlyScheduleTable: React.FC<IProps> = ({ data, selectedDate }) => {
  const isDesktop = useMediaQuery("(min-width: 1100px)");

  const getPercentageFree = (capacity: number, reserved: number) => {
    if (capacity === 0) {
      return 0;
    } else {
      const percentageFree = ((capacity - reserved) / capacity) * 100;
      return percentageFree;
    }
  };

  return (
    <>
      {data && (
        <>
          {" "}
          {isDesktop ? (
            <HourlyScheduleDesktopTable data={data} getPercentageFree={getPercentageFree} />
          ) : (
            <HourlyScheduleMobileTable data={data} getPercentageFree={getPercentageFree} />
          )}
          <BuyTicketsButton />
        </>
      )}
    </>
  );
};

export default HourlyScheduleTable;
